(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["clan-purchase-signals"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('clan-emi-options')) {
    class ClanEmiOptions extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-information, featured-product-information, .shopify-section') || document;
        this.onProductSelect = this.onProductSelect.bind(this);
        this.scope.addEventListener('shopify:product:select', this.onProductSelect);
      }

      disconnectedCallback() {
        this.scope?.removeEventListener('shopify:product:select', this.onProductSelect);
      }

      onProductSelect(event) {
        if (!event.promise || typeof event.promise.then !== 'function') return;
        const wasOpen = Boolean(this.querySelector('details')?.open);

        event.promise.then(({ detail }) => {
          const html = detail?.html;
          if (!html) return;
          const selector = `clan-emi-options[data-block-id="${this.dataset.blockId}"]`;
          const replacement = html.querySelector(selector);
          if (!replacement) return;
          const clone = replacement.cloneNode(true);
          if (wasOpen) clone.querySelector('details')?.setAttribute('open', '');
          this.replaceWith(clone);
        }).catch(() => {});
      }
    }

    customElements.define('clan-emi-options', ClanEmiOptions);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clan-stock-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('clan-stock-delivery')) {
    class ClanStockDelivery extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-information, featured-product-information, .shopify-section') || document;
        this.onProductSelect = this.onProductSelect.bind(this);
        this.scope.addEventListener('shopify:product:select', this.onProductSelect);
        this.renderDeliveryWindow();
      }

      disconnectedCallback() {
        this.scope?.removeEventListener('shopify:product:select', this.onProductSelect);
      }

      renderDeliveryWindow() {
        const output = this.querySelector('[data-delivery-window]');
        if (!output) return;
        const minDays = Number.parseInt(this.dataset.minDays || '2', 10);
        const maxDays = Math.max(minDays, Number.parseInt(this.dataset.maxDays || '5', 10));
        const start = new Date();
        const end = new Date();
        start.setDate(start.getDate() + minDays);
        end.setDate(end.getDate() + maxDays);
        const formatter = new Intl.DateTimeFormat(this.dataset.locale || 'en-IN', {
          day: 'numeric',
          month: 'short'
        });
        const startParts = Object.fromEntries(
          formatter.formatToParts(start).map(({ type, value }) => [type, value])
        );
        const endParts = Object.fromEntries(
          formatter.formatToParts(end).map(({ type, value }) => [type, value])
        );
        const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
        const range = this.dataset.layout === 'utility_row'
          ? (sameMonth
            ? `${startParts.day}–${endParts.day} ${endParts.month}`
            : `${startParts.day} ${startParts.month} – ${endParts.day} ${endParts.month}`)
          : `${formatter.format(start)} – ${formatter.format(end)}`;
        output.textContent = output.dataset.deliveryPrefix
          ? `${output.dataset.deliveryPrefix} ${range}`
          : range;
      }

      onProductSelect(event) {
        if (!event.promise || typeof event.promise.then !== 'function') return;
        event.promise.then(({ detail }) => {
          const html = detail?.html;
          if (!html) return;
          const selector = `clan-stock-delivery[data-block-id="${this.dataset.blockId}"]`;
          const replacement = html.querySelector(selector);
          if (replacement) this.replaceWith(replacement.cloneNode(true));
        }).catch(() => {});
      }
    }

    customElements.define('clan-stock-delivery', ClanStockDelivery);
  }
  } catch(e) { console.error(e); }
})();

})();
